import axios from 'axios';
import { setResponseInterceptor, setRequestInterceptor } from './interceptors';
import { paramsSerializer } from './utils';
import { API_PREFIX_URL } from '@/constants';

// 默认超时时间
axios.defaults.timeout = 150000;
// 返回其他状态码
axios.defaults.validateStatus = status => status >= 200 && status < 400;
// 跨域保存允许保存 cookie
// axios.defaults.withCredentials = true;
// axios.defaults.params = { lang: 'zh_CN' };
axios.defaults.responseType = 'json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

/** 纯净微服务 */
export const pureFetch = axios.create({
  baseURL: `${API_PREFIX_URL}`,
  paramsSerializer,
});
setResponseInterceptor(pureFetch);
setRequestInterceptor(pureFetch);

/** user 微服务 */
export const userFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/user`,
  paramsSerializer,
});
setRequestInterceptor(userFetch);
setResponseInterceptor(userFetch);

/** customer 微服务 */
export const customerFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/customer`,
  paramsSerializer,
});
setRequestInterceptor(customerFetch);
setResponseInterceptor(customerFetch);

/** Cart 微服务 */
export const cartFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/cart`,
  paramsSerializer,
});
setRequestInterceptor(cartFetch);
setResponseInterceptor(cartFetch);

/** Product 微服务 */
export const productFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/product`,
  paramsSerializer,
});
setRequestInterceptor(productFetch);
setResponseInterceptor(productFetch);

/** Sys 微服务 */
export const sysFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/sys`,
  paramsSerializer,
});

setRequestInterceptor(sysFetch);
setResponseInterceptor(sysFetch);

/** Metadata 微服务 */
export const metadataFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/metadata`,
  paramsSerializer,
});
setRequestInterceptor(metadataFetch);
setResponseInterceptor(metadataFetch);

/**third */
export const thirdFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/third`,
  paramsSerializer,
});
setRequestInterceptor(thirdFetch);
setResponseInterceptor(thirdFetch);

/**order */
/**orderDetail */
export const orderFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/order`,
  paramsSerializer,
});
setRequestInterceptor(orderFetch);
setResponseInterceptor(orderFetch);

/**user */
export const noticeFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/user`,
  paramsSerializer,
});
setRequestInterceptor(noticeFetch);
setResponseInterceptor(noticeFetch);

// 下载模板方法
export const exportFetch = axios.create({
  baseURL: `${API_PREFIX_URL}/cart`,
  paramsSerializer,
  responseType: 'blob',
});

setRequestInterceptor(exportFetch);
